import {useEffect, useState} from "react";
import {Colors} from "../constants/colors";

interface SwishStatus {
  page: {
    id: string;
    name: string;
    url: string;
    time_zone: string;
    updated_at: string;
  };
  status: {
    indicator: "none" | "minor" | "major" | "critical";
    description: string;
    color: string;
  };
}

const getSwishStatusColor = (indicator: "none" | "minor" | "major" | "critical") => {
  if (!indicator) {
    return Colors.white;
  }

  switch (indicator) {
    case "none":
      return "#2ecc71"; // Green
    case "minor":
      return "#f39c12"; // Yellow/Orange
    case "major":
      return "#e74c3c"; // Red
    case "critical":
      return "#c0392b"; // Dark Red
    default:
      return Colors.white;
  }
}

const useSwishStatus = () => {

  const [swishStatus, setSwishStatus] = useState<SwishStatus>()

  const fetchSwishStatus = async () => {
    const response = await fetch('https://status.swish.nu/api/v2/status.json');
    if (!response.ok) {
      console.error('Error fetching Swish status:', response.status);
      return undefined;
    }
    return await response.json() as SwishStatus;
  }

  useEffect(() => {
    const updateSwishStatus = () => {
      fetchSwishStatus()
        .then(response => {
          if (response) {
            response.status.color = getSwishStatusColor(response.status.indicator)
          }
          setSwishStatus(response)
        })
        .catch(error => {
          console.error(error)
        });
    }

    updateSwishStatus()

    const intervalId = setInterval(() => {
      updateSwishStatus()
    }, 30000);

    return () => clearInterval(intervalId);
  }, []);

  return swishStatus
}

export default useSwishStatus
